import { useEffect, useState } from "react";
import Grid, { GridColumn, GridHeader, GridRow } from "../Grid/Grid";
import { Card } from "react-bootstrap";
import EquipmentPreviewBlade from "./EquipmentPreviewBlade";
import { Eye, EyeFill } from "react-bootstrap-icons";
import EquipmentTaskListBlade from "./EquipmentTaskListBlade";
import { Button } from "../Button/Button";
import AllEquipmentTaskListBlade from "./AllEquipmentTaskListBlade";

interface propData {
    data: any;
    code: string;
    otherData: any;
}

const headers: GridHeader[] = [
    {
        title: "",
        class: 'text-center',
    },
    {
        title: "Part #",
        class: 'text-start'
    },
    {
        title: "Manufacturer",
        class: 'text-start'
    },
    {
        title: "Model",
        class: 'text-start'
    }
];

export const getBuckets = (data: any): any[] => {
    if (Array.isArray(data?.allBuckets) && data.allBuckets.length > 0) {
        return data.allBuckets;
    }
    return [data?.bucket1, data?.bucket2, data?.bucket3, data?.bucket4, data?.bucket5].filter(Boolean);
};

export const getSelectedBuckets = (data: any): any[] => getBuckets(data).filter((bucket: any) => bucket.isSelected === true);

const SalesQuoteDetailEquiment = (props: propData) => {
    const [rows, setRows] = useState<GridRow[]>([]);
    const [showModal, setShowModal] = useState(false)
    const [selectedData, setSelectedData] = useState<any>()
    const [showTasklistModel, setShowTasklistModel] = useState(false);
    const [selectedEquipment, setSelectedEquipment] = useState('');
    const [tasklistType, setTasklistType] = useState('');
    const [allEquipmentData, setAllEquipmentData] = useState([]);
    const [isShowAllTasklistBlade, setShowAllTasklistBlade] = useState(false);

    useEffect(() => {
        getEquipments()
    }, [props.data])

    const getEquipments = () => {
        const allEquipments: any[] = [];
        const rows: GridRow[] = [];
        for (const bucket of getSelectedBuckets(props.data)) {
            for (const equipment of bucket.equipments || []) {
                if (equipment.showToCustomer === false) continue;
                allEquipments.push(equipment);
                const columns: GridColumn[] = [];
                columns.push({ value: renderImage(equipment) });
                columns.push({ value: <b>{equipment.partNumber}</b> });
                columns.push({ value: <b>{equipment.manufacturer}</b> });
                columns.push({ value: <b>{equipment.model}</b> });
                rows.push({ data: columns, type: 'A' });

                const columns2: GridColumn[] = [];
                columns2.push({
                    value: (
                        <>
                            <div>{equipment.description}</div>
                            {equipment.features && <div>{equipment.features}</div>}
                        </>
                    )
                });
                rows.push({ data: columns2, type: 'B' });
            }
        }
        setAllEquipmentData(allEquipments as any);
        setRows(rows);
    }

    const renderImage = (data: any) => {
        return data.imageURL ? (
            <img src={data.imageURL} height={60} width={60} style={{ width: 60, height: 60, objectFit: 'contain', border: '1px solid lightgray', cursor: 'pointer' }} onClick={() => {
                setSelectedData(data.imageURL)
                setShowModal(true)
            }} />
        ) : null
    }

    const action = (data: any) => {
        return (
            <>
                <div onClick={() => {
                    setSelectedEquipment(data)
                    setShowTasklistModel(true)
                }} className='cursor-pointer'>
                    <EyeFill />
                </div>
            </>
        )
    }

    const onCloseModal = () => {
        setShowModal(false)
    }

    return (
        <>
            {showTasklistModel && <EquipmentTaskListBlade
                isShow={showTasklistModel}
                isClose={() => {
                    setShowTasklistModel(false)
                    setTasklistType('')
                }}
                data={props.data}
                code={props.code}
                id={selectedEquipment}
                type={tasklistType}
                otherData={props.otherData}
            />}
            
            <EquipmentPreviewBlade
                isShow={showModal}
                isClose={onCloseModal}
                data={selectedData}
            />
            <Card className="card-style form-style invoice-call-picture-card p-3" style={{ marginBottom: 50 }}>
                <Grid
                    headers={headers}
                    rows={rows} />
            </Card>
        </>
    )
}

export default SalesQuoteDetailEquiment;